module.exports = __webpack_public_path__ + "img/Warrior-tauren-m-70.be13febf.gif";